import { createAction, props } from '@ngrx/store';

export const MemberSignupPolicyRequest = createAction('[Member signup policy] Request member signup policy');

export const MemberSignupPolicySuccessRequest = createAction('[Member signup policy] Success request member signup policy', props<{ payload: OLO.DTO.MemberSignUpPolicyModel }>());

export const MemberSignupPolicyErrorRequest = createAction('[Member signup policy] Error request member signup policy', (ex: any = null) => ({ ex }));
